<template>
  <div class="content-block md:max-w-xl lg:max-w-2xl relative mb-16" :class="{ 'mx-auto': this.$props.center }">
    <div>
      <div class="heading">
        <span v-html="row.heading" class="top-0 right-0 block mb-1 mb:mb-0 md:absolute" />
      </div>
      <div v-html="row.text" class="response flex-1 body text-2xl leading-snug"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseArticleInterviewRow',
  props: {
    row: Object,
    center: Boolean
  }
}
</script>

<style lang="css" scoped>

  @media (min-width: theme('screens.md')) {
    .heading {
      position: absolute;
      top: 2em;
      margin-left: -14em;
      width: 12em;
      text-align: right;
      position: sticky;
    }

    .heading span {
      top: 0.25em;
    }

    .response {
      margin-top: -1.15em;

      >>> p {
        margin-bottom: 0.25em !important;
      }
    }
  }
</style>
